// @ts-nocheck
import { takeLatest, call, put } from 'redux-saga/effects';
import router from 'components/Router';
import * as types from 'appRedux/actions/clients';
import {
  SHOW_FULLSCREEN_LOADER,
  HIDE_FULLSCREEN_LOADER,
} from 'appRedux/actions/loader';
import { API_URL as API_URI } from 'config/constants';
import * as services from 'utils/apiHelper';
import { successToast } from 'utils/toastHandler';
import getQueryParams from 'utils/getQueryParams';

function* getAllClients(action) {
  const token = localStorage.getItem('token');
  const { payload } = action;
  const query = getQueryParams(payload);

  const data = yield call(
    services.fetchGetApi,
    `${API_URI}/client/?${query}`,
    token,
  );

  if (data) {
    yield put({ type: types.GET_ALL_CLIENTS_SUCCESS, payload: data });
  }
}

function* getClientById(action) {
  const token = localStorage.getItem('token');
  const { id } = action;
  const data = yield call(
    services.fetchGetApi,
    `${API_URI}/client/${id}/`,
    token,
  );

  if (data) {
    yield put({ type: types.GET_CLIENT_BY_ID_SUCCESS, payload: data });
  }
}

function* addClients(action) {
  yield put({ type: SHOW_FULLSCREEN_LOADER });
  const token = localStorage.getItem('token');
  const { payload } = action;

  payload.contact_person = [...payload.contact_person.filter(Boolean)];

  const data = yield call(
    services.fetchPostApi,
    `${API_URI}/client/`,

    payload,
    token,
  );
  if (data) {
    yield put({ type: types.ADD_NEW_CLIENTS_SUCCESS, data });
    yield put({ type: HIDE_FULLSCREEN_LOADER });
    successToast('Client was added successfully.');
  }
}

function* updateById(action) {
  yield put({ type: SHOW_FULLSCREEN_LOADER });
  const token = localStorage.getItem('token');
  const { id, payload } = action;

  payload.contact_person = [...payload.contact_person.filter(Boolean)];

  const data = yield call(
    services.fetchPutApi,
    `${API_URI}/client/${id}/`,
    payload,
    token,
  );

  if (data) {
    yield put({ type: HIDE_FULLSCREEN_LOADER });
    router.navigate('/usermanagement/clients');
    successToast('Client was updated successfully.');
  }
}

function* deleteClientRequest(action) {
  const token = localStorage.getItem('token');
  const {
    payload: { clientId },
  } = action;
  const data = yield call(
    services.fetchDelApi,
    `${API_URI}/client/${clientId}/`,
    token,
  );

  if (data) {
    yield put({
      type: types.DELETE_CLIENT_SUCCESS,
      clientId,
    });
    yield put({ type: types.CLOSE_CONFIRMATION_MODAL });
    successToast('Client was deleted successfully.');
  }
}

function* getStates(action) {
  const token = localStorage.getItem('token');
  const { payload } = action;
  const query = getQueryParams(payload);

  const data = yield call(
    services.fetchGetApi,
    `${API_URI}/state/?country${query}`,
    token,
  );

  if (data) {
    yield put({ type: types.GET_STATES_SUCCESS, payload: data });
  }
}

function* clientsWatcher() {
  yield takeLatest(types.GET_ALL_CLIENTS_REQUEST, getAllClients);
  yield takeLatest(types.GET_CLIENT_BY_ID_REQUEST, getClientById);
  yield takeLatest(types.ADD_NEW_CLIENTS_REQUEST, addClients);
  yield takeLatest(types.UPDATE_CLIENT_BY_ID_REQUEST, updateById);
  yield takeLatest(types.DELETE_CLIENT_REQUEST, deleteClientRequest);
  yield takeLatest(types.GET_STATES_REQUEST, getStates);
}

export default clientsWatcher;
